var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavorite3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2041_280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8643 2.68981C17.5096 0.683165 14.0076 1.0441 11.8463 3.27418L10.9998 4.14645L10.1533 3.27418C7.99632 1.0441 4.49007 0.683165 2.13538 2.68981C-0.563058 4.99293 -0.704855 9.12652 1.70999 11.623L10.0244 20.2082C10.5616 20.7625 11.4338 20.7625 11.9709 20.2082L20.2854 11.623C22.7045 9.12652 22.5627 4.99293 19.8643 2.68981Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2041_280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite3);
export default __webpack_public_path__ + "static/media/favorite3.3730728e0fd9172b54b49e25f84317b2.svg";
export { ForwardRef as ReactComponent };